import { createContext } from "react";
import { createContextualCan } from "@casl/react";
import type { AppAbility } from "./utils/abilities";

export const AbilityContext = createContext<AppAbility>(undefined!);

export default createContextualCan(AbilityContext.Consumer);
